// Utils
import { asyncResource } from '../../utils/services/http/asyncResource/asyncResource';

// Constants
import { ResourceTypes } from '../../utils/services/http/asyncResource/asyncResourceConstants';
import { CmsEntities } from '../../cms/cmsConstants';

const CACHEBUSTER = '251117'; // update to today's date whenever we need to incorporate an emoji update
const EMOJI_DATA_URL = `https://static.milanote.com/emoji-assets/data.json?v=${CACHEBUSTER}`;

export const fetchEmojiData = () => async (dispatch: Function) => {
    dispatch(
        asyncResource(
            ResourceTypes.cms,
            CmsEntities.EMOJI,
        )(async () => {
            const response = await fetch(EMOJI_DATA_URL);
            return response.json();
        }),
    );
};
